export const allStarPlayersQuery = `
query($slug: ID){
  event(slug: $slug) {
    id
    slugname
    externalId
    year
    startTime
    week
    venue
    description
    location
    gameNumber
    broadcaster
    eventStatus
    period
    homeScore
    homePeriodScores
    visitorScore
    visitorPeriodScores
    urlTicket
    league
    urlPreview
    seasonSegment
    urlStreaming
    addToCalendarId
    gameStatus
    homeTeam {
      ...TeamInfo
    }
    awayTeam {
      ...TeamInfo
    }
  }
}

fragment TeamInfo on Team {
  officialId
  fullName
  urlLogo
  players {
    officialId
    slug
    name
    firstName
    lastName
    position
    profileUrl
    rosterStatus
    experience
    jerseyNum
    currentTeam {
      officialId
      fullName
      injuryStatus
    }
    accolades {
      awardName
      years
    }
  }
}
`
